import classNames from 'classnames';
import { PropsWithChildren } from 'react';

export enum AlertVariant {
  Error,
}

type AlertProps = {
  className?: string;
  onClick?: () => void;
  variant?: AlertVariant;
};

function Alert({
  children,
  className,
  onClick,
  variant = AlertVariant.Error,
}: PropsWithChildren<AlertProps>) {
  const getVariantClasses = (variant: AlertVariant): string => {
    switch (variant) {
      case AlertVariant.Error:
      default:
        return 'bg-red-800/90 text-white/80';
    }
  };

  return (
    <div
      className={classNames('rounded-lg p-3', getVariantClasses(variant), className)}
      data-testid="alert"
      onClick={() => onClick && onClick()}
      role="alert"
    >
      {children}
    </div>
  );
}

export default Alert;
